export type InvoiceEntrySourceInfo = {
  label: string
  shortLabel: string
  icon: string
  color: string
}

const entrySources: Record<number, InvoiceEntrySourceInfo> = {
  0: {
    label: 'فرم وب',
    shortLabel: 'فرم وب',
    icon: 'la-keyboard',
    color: 'primary',
  },
  1: {label: 'API نسخه ۱', shortLabel: 'API 1', icon: 'la-code', color: 'info'},
  2: {label: 'فایل اکسل', shortLabel: 'اکسل', icon: 'la-file-excel', color: 'success'},
  3: {
    label: 'نرم‌افزار سپیدار',
    shortLabel: 'سپیدار',
    icon: 'la-calculator',
    color: 'warning',
  },
  4: {
    label: 'پایگاه داده / سرویس همگام‌سازی',
    shortLabel: 'همگام‌سازی',
    icon: 'la-database',
    color: 'secondary',
  },
  5: {label: 'پایانه فروش', shortLabel: 'POS', icon: 'la-cash-register', color: 'dark'},
  6: {label: 'API نسخه ۲', shortLabel: 'API 2', icon: 'la-code', color: 'info'},
  7: {
    label: 'فرم وب کامل',
    shortLabel: 'فرم کامل',
    icon: 'la-file-alt',
    color: 'primary',
  },
  8: {
    label: 'فرم وب ساده',
    shortLabel: 'فرم ساده',
    icon: 'la-file',
    color: 'primary',
  },
  9: {
    label: 'فرم وب قیمت تمام‌شده',
    shortLabel: 'قیمت تمام‌شده',
    icon: 'la-coins',
    color: 'warning',
  },
  10: {
    label: 'فرم وب قیمت تمام‌شده پیشرفته',
    shortLabel: 'قیمت پیشرفته',
    icon: 'la-chart-line',
    color: 'warning',
  },
  11: {
    label: 'صورتحساب خودکار',
    shortLabel: 'خودکار',
    icon: 'la-magic',
    color: 'success',
  },
  12: {
    label: 'خروجی PDF سازمان',
    shortLabel: 'PDF سازمان',
    icon: 'la-file-pdf',
    color: 'danger',
  },
  13: {
    label: 'خروجی ZIP کارپوشه',
    shortLabel: 'ZIP کارپوشه',
    icon: 'la-file-archive',
    color: 'danger',
  },
  14: {
    label: 'خروجی اکسل کارپوشه',
    shortLabel: 'اکسل کارپوشه',
    icon: 'la-file-excel',
    color: 'danger',
  },
  // A CRM sales case's «صدور صورتحساب» / «صدور پیش‌فاکتور», registered by the system user «CRM».
  15: {
    label: 'CRM',
    shortLabel: 'CRM',
    icon: 'la-handshake',
    color: 'info',
  },
  // ASA's invoice for a business's wallet charge, issued by the system after the online payment.
  16: {
    label: 'شارژ کیف پول',
    shortLabel: 'کیف پول',
    icon: 'la-wallet',
    color: 'success',
  },
}

const unknownEntrySource: InvoiceEntrySourceInfo = {
  label: 'روش ثبت نامشخص',
  shortLabel: 'نامشخص',
  icon: 'la-question-circle',
  color: 'secondary',
}

/** The text colour of an entry's icon: Metronic's «secondary» is too pale for an icon, so it is grey. */
export const entrySourceTextClass = (source: InvoiceEntrySourceInfo) =>
  source.color === 'secondary' ? 'text-gray-600' : `text-${source.color}`

/** The soft badge an entry's icon sits on, in its own colour. */
export const entrySourceBadgeClass = (source: InvoiceEntrySourceInfo) =>
  source.color === 'secondary' ? 'badge-light' : `badge-light-${source.color}`

export const getInvoiceEntrySourceInfo = (entryType?: number | null) =>
  entryType === undefined || entryType === null
    ? unknownEntrySource
    : entrySources[entryType] || unknownEntrySource

// «روش ثبت» in the list's filter: every channel an invoice can be registered through
// (MegaPayBackend.Models.EntryType), in the order of the enum.
export const getInvoiceEntrySourceOptions = () =>
  Object.keys(entrySources)
    .map(Number)
    .sort((a, b) => a - b)
    .map((entryType) => ({value: String(entryType), label: entrySources[entryType].label}))
